import ContentSection from "./ContentSection";

function CarPartsContent(props: any) {
  const {
    heading, backgroundColor, content: defaultContent, contentIds,
  } = props;
  if (contentIds && contentIds.length > 0) {
    return (
      contentIds.map((eachContent: any) => {
        const { content, uiType } = eachContent?.uiDetails || {};
        if (uiType === "FAQ" && content.faqs) {
          return content.faqs.map((eachFaq, index) => (
            <ContentSection
              backgroundColor={backgroundColor}
              heading={eachFaq.question}
              content={eachFaq.answer}
              article={eachFaq.article}
              key={index}
            />
          ));
        }
        return null;
      })
    );
  }

  if (!defaultContent) {
    return null;
  }

  return <ContentSection backgroundColor={backgroundColor} heading={heading} content={defaultContent} />;
}

export default CarPartsContent;
